import React from "react";
import { motion } from "framer-motion";
import { IN_DEVELOPMENT } from "../data/content";

export default function Originals() {
  return (
    <section id="originals" className="vw-section relative" data-testid="vw-originals">
      {/* Diagonal accent line */}
      <div className="absolute top-0 left-0 right-0 h-px">
        <div className="vw-divider" />
      </div>

      <div className="vw-container">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="vw-eyebrow mb-6">DEVELOPMENT SLATE · ORIGINAL IPs</div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.92] tracking-tight max-w-[16ch]">
              Worlds we're <span className="font-serif-italic font-normal text-[var(--vw-cyan)]">building</span>. Territories are open.
            </h2>
          </div>
          <p className="max-w-md text-[var(--vw-text-dim)] leading-relaxed">
            Original animated properties in active development — created, written, designed and produced under one roof. Available for co-production, licensing and territorial acquisition.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {IN_DEVELOPMENT.map((ip, i) => (
            <motion.article
              key={ip.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: i * 0.12 }}
              className="group relative border border-[var(--vw-border)] hover:border-[var(--vw-orange)] transition-colors bg-[var(--vw-bg-soft)]"
              data-testid={`vw-original-${ip.id}`}
            >
              <div className="aspect-[3/4] relative overflow-hidden">
                <img
                  src={ip.thumb}
                  alt={ip.title}
                  className="w-full h-full object-cover opacity-60 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--vw-bg-soft)] via-transparent to-transparent" />
                <div className="absolute top-4 left-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-orange)] border border-[var(--vw-orange)] px-2.5 py-1 bg-black/50">
                  <span className="w-1.5 h-1.5 bg-[var(--vw-orange)] vw-blink" />
                  IN DEVELOPMENT
                </div>
              </div>
              <div className="p-6">
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-cyan)] mb-2">
                  {ip.format}
                </div>
                <h3 className="font-display text-3xl leading-[0.95] tracking-tight mb-3">
                  {ip.title}
                </h3>
                <p className="text-sm text-[var(--vw-text-dim)] leading-relaxed mb-4 line-clamp-3">
                  {ip.logline}
                </p>
                <div className="border-t border-[var(--vw-border)] pt-4 font-mono text-[10px] uppercase tracking-[0.24em] text-[var(--vw-text-mute)]">
                  {ip.stage}
                </div>
              </div>
            </motion.article>
          ))}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-6 border-t border-[var(--vw-border)] pt-10">
          <p className="font-serif-italic text-2xl md:text-3xl text-[var(--vw-text-dim)] max-w-[42ch] leading-[1.2]">
            Request the private slate deck — talent attachments, comparables, and territorial availability.
          </p>
          <a href="#contact" className="vw-btn-primary shrink-0 ml-auto" data-testid="vw-originals-cta">
            Request Slate Deck
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
          </a>
        </div>
      </div>
    </section>
  );
}
